import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Controller } from "swiper";
import "swiper/swiper-bundle.css";
import "./styles.css";

SwiperCore.use([Navigation, Pagination, Controller]);

const images = [
  "cowboy.jpg",
  "twins.jpg",
  "dudes.jpg",
  "hair.jpg",
  "girl.jpeg",
  "empty.jpg",
  "bosque.jpg",
  "sheep.jpg",
  "stirfry.jpg",
  "sands.jpg",
  "nerd.jpg",
  "bond.jpg",
  "bday.jpg",
  "snow.jpg",
  "year.jpg",
  "smitten.jpg",
  "smittenboy.jpg",
  "flew1.jpg",
  "flew2.jpg",
  "flew3.jpg",
  "flew4.jpg",
  "flew5.jpg",
  "gknew.jpg",
  "special.jpg",
  "ring.jpg",
  "vows.jpg",
  "years.png",
  "ever.jpg",
];
const messages = [
  "There was once a boy from New Mexico... (swipe right)",
  "who moved back home to take care of some twins.",
  "He enjoyed late nights with funny people...",
  "and made bad decisions about haircuts (yikes 🤨).",
  "But little did he know... he was just across the street from his future wife.",
  "He tried making his intentions known, but her response was blank.",
  "But at his going-away party in Algodones.",
  "He made his move after saying her jacket felt like a sheep 😘.",
  "Next he sent her a photo of a stir fry to show how he was a provider. ... (wait does he actually get the girl at the end of this story?? 😅)...",
  "They camped halfway in Raton to see each other (snagging photos every so often).",
  "And though the boy was a nerd...",
  "they had a bond that they couldn't deny.",
  "They celebrated birthdays,",
  "enjoyed the snow,",
  "and rang in new years.",
  "The boy was smitten.",
  "The girl was smitten.",
  "The years flew",
  "and flew",
  "and flew",
  "and flew.",
  "Boy knew.",
  "Girl knew.",
  "That they had something special.",
  "So he put a ring on it...",
  "And on Aug 24th, 2019 they said their vows.",
  "And two years later...",
  "They're still happily ever after. Happy Anniversary my love. - Z",
];

function App() {
  const [activeMessage, setActiveMessage] = useState(messages[0]);

  const slides = [];
  images.forEach((img, i) => {
    slides.push(
      <SwiperSlide key={`slide-${i}`} tag="li">
        <div
          style={{
            width: "375px",
            height: "375px",
            listStyle: "none",
            backgroundImage: `url(/images/${img})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          // width="500px"
          // src={img}
          // style={{ listStyle: "none" }}
          alt={`Slide ${i}`}
        />
      </SwiperSlide>
    );
  });

  return (
    <React.Fragment>
      <Swiper
        id="main"
        tag="section"
        wrapperTag="ul"
        // navigation
        // pagination
        spaceBetween={0}
        slidesPerView={1}
        // onInit={(swiper) => console.log("Swiper initialized!", swiper)}
        onSlideChange={(swiper) => {
          setActiveMessage(messages[swiper.activeIndex]);
          // console.log("Slide index changed to: ", swiper.activeIndex);
        }}
        // onReachEnd={() => console.log("Swiper end reached")}
      >
        {slides}
      </Swiper>
      <p>{activeMessage}</p>
    </React.Fragment>
  );
}

export default App;
